import { FC, HTMLAttributes } from 'react';
import TitleBarButton from './TitleBarButton';
import { IDataTestId } from '../../../../../../custom';

type TProps = {
  hideCloseButton: boolean;
} & IDataTestId &
  HTMLAttributes<HTMLButtonElement>;

const CloseButton: FC<TProps> = ({ hideCloseButton, ...rest }) => {
  return <TitleBarButton hide={hideCloseButton} variant="close" buttonProps={rest} />;
};

export default CloseButton;
